import compatibilityScoreList from './actions/compatibilityScoreList';
import compatibilityScoreChange from './actions/compatibilityScoreChange';
import compatibilityScoreCreate from './actions/compatibilityScoreCreate';
import compatibilityScoreDetail from './actions/compatibilityScoreDetail';
import getCompatibilityScore from './getters/getCompatibilityScore';
import compatibilityScoreUpload from './mutations/compatibilityScoreUpload';

const actions = {
    compatibilityScoreList,
    compatibilityScoreChange,
    compatibilityScoreCreate,
    compatibilityScoreDetail
};

const mutations = {
    compatibilityScoreUpload
};

const getters = {
    getCompatibilityScore
};

export default { actions, mutations, getters };
